import { ROUTES } from '@/routes';
import { connectColors } from '@/theme/colors';
import { Button } from '@lego/connect-components-react';
import { Text } from '@lego/klik-ui';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '../context/auth-context';

export const LoginPage = (): React.ReactElement => {
  const { login, isAuthenticated, isLoading } = useAuthContext();

  if (isAuthenticated) {
    return <Navigate to={ROUTES.Home.path} />;
  }

  return (
    <div
      style={{
        backgroundColor: connectColors.core.gray[50],
        minWidth: '100vw',
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '64px',
      }}
    >
      <Text textStyle="4xl">
        Welcome to <span style={{ fontWeight: 'bold' }}>Price Data Hub</span>
      </Text>
      <div
        style={{
          minWidth: '400px',
          backgroundColor: 'white',
          padding: '16px',
          borderRadius: 'md',
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          alignItems: 'center',
        }}
      >
        <Text textStyle="2xl">Please sign in to continue</Text>
        <Button loading={isLoading} size="large" onClick={login}>
          Sign In
        </Button>
      </div>
    </div>
  );
};
